import React from 'react';
import { StarIcon } from 'lucide-react';
import type { Testimonial } from '../data/content';
type TestimonialGridProps = {
  items: Testimonial[];
};
function Stars({
  count
}: {
  count: number;
}) {
  return <div className="flex gap-0.5" aria-label={`${count} de 5 estrellas`} data-id="element-235" data-mp="3tnyoyqdy9zar">
      {Array.from({
      length: 5
    }).map((_, index) => <StarIcon key={index} className={`h-3.5 w-3.5 ${index < count ? 'fill-amber text-amber' : 'text-line'}`} aria-hidden="true" data-id="element-236" data-mp="2hfghhvl6lfm" data-mpi={index} />)}
    </div>;
}
export function TestimonialGrid({
  items
}: TestimonialGridProps) {
  return <ul className="grid gap-4 sm:grid-cols-2" data-id="element-237" data-mp="u9wfpktt52po">
      {items.map(item => <li key={item.name} className="flex flex-col gap-3 rounded-2xl border border-line bg-paper p-5 shadow-card" data-id="element-238" data-mp="gfvmf6lmk7wp">
          <Stars count={item.stars} data-id="element-239" data-mp="ldxak5xwqxf1" />
          <blockquote className="text-[14.5px] leading-relaxed text-night" data-id="element-240" data-mp="195m57sy7bxz5">
            “{item.quote}”
          </blockquote>
          <div className="mt-auto flex items-center gap-3 border-t border-line pt-3" data-id="element-241" data-mp="1dx466h085yk4">
            <img src={item.photo} alt="" className="h-10 w-10 rounded-full object-cover" width={80} height={80} loading="lazy" data-id="element-242" data-mp="2x3z7jn301rl7" />
            <div data-id="element-243" data-mp="2t4qekkfs9xqp">
              <p className="text-[13px] font-extrabold leading-tight text-night" data-id="element-244" data-mp="2t12jhguox39v">{item.name}</p>
              <p className="text-[11.5px] leading-tight text-muted" data-id="element-245" data-mp="36vv9584anzu6">{item.role}</p>
            </div>
          </div>
        </li>)}
    </ul>;
}